import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Fail closed: with no database configured the app shows a notice instead of guessing.
export const supabase: SupabaseClient | null = url && key ? createClient(url, key) : null;

export function db(): SupabaseClient {
  if (!supabase) throw new Error('The app is not connected to a database.');
  return supabase;
}
